import { TabContext, TabList } from "@mui/lab";
import { Box, Grid, Tab, styled, Button } from "@mui/material";
import CardView from "../../components/Card";
import FlexBox from "../../components/FlexBox";
import KYCCard from "../../components/KYCCard";
import TopBanner from "../../components/TopBanner";
import { H3, H4 } from "../../components/Typography";
import * as Models from "../../models";
import ConsoleLogger from "../../components/ConsoleLogger";
import Carousel from "react-material-ui-carousel";
import MFDashboard from "../mfScreens/MFDashboard";
import CircularProgress from "@mui/material/CircularProgress";
import { Player } from "@lottiefiles/react-lottie-player";
import ComingSoon from "../../assets/Lottifies/comingSoon.json";
import { FC, useState, useEffect, SyntheticEvent } from "react";
import { load, remove, save } from "../../constants/storage";
import DashboardNavbar from "../../components/DashboardNavbar";
import Footer from "../../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import DigitalGoldTabScreen from "../goldSilverScreens/DigitalGoldTabScreen";
import {
  getLivePrices,
  getInvestments,
} from "../../redux/actions/GoldSilverAction";
import { useAppDispatch } from "../../store/hooks";
import { toast } from "react-hot-toast";
import { getMFPortfolioData } from "../../redux/actions/PortfolioAction";
import StaticCard from "../../components/StaticCard";
import { getUSerInfo } from "../../redux/actions";
import KYCReduModel from "../../components/KYCReduModel";
import { activateKYC, skipMFKYC } from "../../redux/actions/KYCAction";
import {
  DashboardCardData,
  dashboardCoursalItems,
} from "../../constants/constant";
import DashBoardCard from "../../components/DashBoardCard";

const Dashborad: FC = () => {
  const [value, setValue] = useState("1");
  //cards data
  const [metalType, setMetalType] = useState("Gold");
  const [type, setType] = useState("Gold");
  const [loading, setLoading] = useState(true);
  const [goldLivePriceWithGST, setGoldLivePriceWithGST] = useState();
  const [silverLivePriceWithGST, setSilverLivePriceWithGST] = useState();
  const [goldLivePrice, setGoldLivePrice] = useState();
  const [silverLivePrice, setSilverLivePrice] = useState();
  const [goldGST, setGoldGST] = useState();
  const [silverGST, setSilverGST] = useState();
  const [amount, setAmmount] = useState();

  const [mfDetails, setMfDetails] = useState<any>();
  const [showReKYC, setShowReKYC] = useState(false);

  //Investment Details
  const [goldGrowth, setGoldGrowth] = useState<any>();
  const [silverGrowth, setSilverGrowth] = useState<any>();
  const [totalGoldAmt, setTotalGoldAmt] = useState();
  const [totalGold, setTotalGold] = useState();
  const [totalSilverAmt, setTotalSilverAmt] = useState();
  const [totalSilver, setTotalSilver] = useState();
  const [goldCurrentValue, setGoldCurrentValue] = useState();
  const [silverCurrentValue, setSilverCurrentValue] = useState();
  let navigate = useNavigate();
  let location = useLocation();
  const dispatch = useAppDispatch();
  const [showSumbmitedKYC, setShowSumbmitedKYC] = useState(false);
  const [completeKYC, showCompleteKYC] = useState(false);
  const [activeKYCCard, setActiveKYCCard] = useState(false);

  useEffect(() => {
    checkToken();

    ConsoleLogger.log("This is a log message");
    ConsoleLogger.warn("This is a warning message");
    ConsoleLogger.error("This is an error message");
  }, []);

  //KYC Redu model
  const [kycReduModel, setKYCReduModel] = useState(false);
  const handleKYCReduCloseModal = async () => {
    setKYCReduModel(false);
    await skipKycMutualFundApi();
  };

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined && !location.state?.justLoggedIn) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      let activeTab: any = load("tabState");
      setValue(activeTab);
      getPrices();
      getInvestmentsData();
      getPortfolioData();
      getUserData();
    }
  };

  useEffect(() => {
    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);
  function onBackButtonEvent(e: PopStateEvent) {
    e.preventDefault();
    window.history.pushState(null, "", window.location.pathname);
  }
  const skipKycMutualFundApi = async () => {
    let token = await load("token");
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    const data: Models.SkipKycMutualFundRequest = {
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };

    setShowReKYC(false);

    dispatch(skipMFKYC(data, `bearer ${token}`))
      .then(async (response: any) => {
        await getUserData();
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const getPortfolioData = async () => {
    let token: any = load("token");
    let userDetail: any = load("userData");
    let userDeatils = JSON.parse(userDetail);
    const data: Models.MutualFundPortfolioRequest = {
      id: userDeatils.id,
      mobile: userDeatils.mobile,
      partner: userDeatils?.refcode,
      source: "web",
    };
    dispatch(getMFPortfolioData(data, `bearer ${token}`))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          return;
        }
        setMfDetails(response?.mf_data ?? "0");
      })
      .catch((error: any) => {
        console.log("getPortfolioData__error", error);
      });
  };
  //Get Live Prices
  const getPrices = async () => {
    setLoading(true);
    let token = await load("token");
    dispatch(getLivePrices(token))
      .then(async (response: any) => {
        //silver with GST
        let silverGSTPrice = response.sBuy + response.sBuyGst;
        setSilverLivePriceWithGST(silverGSTPrice);
        //gold with GST
        let goldGSTPrice = response.gBuy + response.gBuyGst;
        setGoldLivePriceWithGST(goldGSTPrice);
        setSilverLivePrice(response.sBuy);
        setGoldLivePrice(response.gBuy);
        setSilverGST(response.sBuyGst);
        setGoldGST(response.gBuyGst);
        setAmmount(metalType === "Gold" ? response.gBuy : response.sBuy);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error);
        setLoading(false);
      });
  };

  //Get Investments Prices
  const getInvestmentsData = async () => {
    setLoading(true);
    let token = await load("token");
    const countryCode: any = "91";
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    var numberWithCode = countryCode + finalUser.mobile;
    dispatch(getInvestments(numberWithCode, token))
      .then(async (response: any) => {
        setTotalGold(response?.totalGold.toFixed(4) ?? "0");
        setTotalGoldAmt(response?.totalGoldAmt ?? "0");
        setTotalSilver(response?.totalSilver.toFixed(4) ?? "0");
        setTotalSilverAmt(response?.totalSilverAmt ?? "0");
        setGoldGrowth(response?.goldChangedBy ?? "0");
        setSilverGrowth(response?.silverChangedBy ?? "0");
        setSilverCurrentValue(response?.silverCurrentValue ?? "0");
        setGoldCurrentValue(response?.goldCurrentValue ?? "0");
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const handleChange = (_: SyntheticEvent, newValue: string) => {
    setValue(newValue);

    save("tabState", newValue);
  };

  const getUserData = async () => {
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");
    const req = {
      id: finalUser?.id,
      mobile: finalUser?.mobile,
      partner: finalUser?.refcode,
      source: "web",
    };

    dispatch(getUSerInfo(req, `bearer ${token}`))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          return;
        }
        await save("userData", JSON.stringify(response?.data[0]));

        let acruUser = response?.data[0];
        if (acruUser?.rekyc) {
          if (acruUser?.user_status === "KYCSUBMITTED") {
            showCompleteKYC(false);
            setShowSumbmitedKYC(true);
            setShowReKYC(false);
            return;
          }
          setShowReKYC(true);
          return;
        }
        if (acruUser.user_status === "ACTIVE") {
          showCompleteKYC(false);
          setShowSumbmitedKYC(false);
          setActiveKYCCard(true);
          return;
        }
        if (acruUser.user_status === "KYCSUBMITTED") {
          showCompleteKYC(false);
          setShowSumbmitedKYC(true);
          setShowReKYC(false);
          return;
        }
        if (acruUser.user_status === "KYCAPPROVED") {
          await activateKYCAction();
          showCompleteKYC(false);
          setShowSumbmitedKYC(false);
          setActiveKYCCard(true);
        } else {
          setShowReKYC(false);
          showCompleteKYC(true);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        console.log(`Error: ${error} | ${error?.description}`);
      });
  };

  const activateKYCAction = async () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    let token = load("token");
    const req: Models.MutualFundKYCRequestStatus = {
      id: userDetails.id,
      mobile: userDetails.mobile,
      partner: userDetails?.refcode,
    };
    dispatch(activateKYC(req, `bearer ${token}`))
      .then(async (response: any) => {})
      .catch((error: any) => {
        console.log("login__error", error);
      });
  };

  const clickCompleteKYC = () => {
    let userDetail: any = load("userData");
    let userDetails = JSON.parse(userDetail);
    if (userDetails?.user_status === "SIGNEDUP") {
      navigate("/userdetails");
      return;
    }
    if (userDetails?.user_status === "BANK") {
      navigate("/kycinformation", {
        state: {
          KYCStatus: 1,
        },
      });
      return;
    }
    if (
      userDetails?.user_status === "KYC" ||
      userDetails?.user_status === "KYC2" ||
      userDetails?.user_status === "KYC3"
    ) {
      navigate("/kycinformation", {
        state: {
          KYCStatus: 2,
        },
      });
      return;
    }
    if (userDetails?.user_status === "ESIGNSUBMITTED") {
      navigate("/esign");
      return;
    }

    navigate("/kycinformation", {
      state: {
        KYCStatus: 0,
      },
    });
  };

  const handleSaveKYCReduModel = () => {
    navigate("/kycinformation", {
      state: {
        KYCStatus: 0,
      },
    });
    setKYCReduModel(false);
  };

  const carouselSettings = {
    autoPlay: true,
    autoPlaySpeed: 3000, // Adjust the speed as per your preference (in milliseconds)
  };

  const onClickBottomCard = (name: any) => {
    switch (name) {
      case "Save Now Buy Later":
        navigate("/goalDashboard");
        break;
      case "Gold Coins":
        navigate("/goldcoin");
        break;
      case "Gifting":
        navigate("/gifting");
        break;
      default:
        break;
    }
  };

  return (
    <Grid
      sx={{
        background: "#F6F6F6",
      }}
    >
      <DashboardNavbar />
      <TabContext value={value}>
        <Box sx={sxStyleTabBox}>
          <FlexBox
            padding="0"
            alignItems="center"
            justifyContent="space-between"
          >
            <TabList
              sx={{
                width: "100%",
                mb: {
                  md: 1,
                  xs: -2,
                },
              }}
              onChange={handleChange}
            >
              <Tab sx={tabStyle} label="Home" value="1" />
              <Tab sx={tabStyle} label="Digital Gold/Silver" value="2" />
              <Tab sx={tabStyle} label="Mutual Funds" value="3" />
              <Tab sx={tabStyle} label="Insurance" value="4" />
            </TabList>
          </FlexBox>
          {loading ? (
            <Grid
              height="100vh"
              display="flex"
              flexDirection="column"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Grid>
          ) : (
            <>
              {value === "1" && (
                <>
                  <TopBanner
                    imageLink="https://acru-asset.s3.us-east-1.amazonaws.com/assets/bannerRight.svg"
                    leftImageLink="https://acru-asset.s3.us-east-1.amazonaws.com/assets/bannerLeft.svg"
                  />
                  <Grid container sx={sxStyleCardView}>
                    <Grid sx={sxStyleCard}>
                      <CardView
                        title={"Digital Gold"}
                        investedAmt={totalGoldAmt ?? "0"}
                        subAmt={goldCurrentValue ?? "0"}
                        icon="https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                        returns={goldGrowth ?? "0"}
                      />
                      <CardView
                        title={"Digital Silver"}
                        investedAmt={totalSilverAmt ?? "0"}
                        subAmt={silverCurrentValue ?? "0"}
                        icon="https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
                        returns={silverGrowth ?? "0"}
                      />
                      <CardView
                        title={"Mutual Funds"}
                        investedAmt={mfDetails?.invested_amount ?? "0"}
                        subAmt={mfDetails?.current_value ?? "0"}
                        icon="https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                        returns={mfDetails?.profit ?? "0"}
                      />
                    </Grid>
                    <Grid sx={sxStyleExtraCard}>
                      {completeKYC ? (
                        <KYCCard
                          title={"Complete your KYC"}
                          onPress={() => clickCompleteKYC()}
                          buttonTitle="Complete KYC"
                        />
                      ) : showSumbmitedKYC ? (
                        <KYCCard
                          title={"Your KYC is under process"}
                          onPress={() => {
                            navigate("/esign");
                          }}
                          buttonTitle="Check Status"
                        />
                      ) : showReKYC ? (
                        <KYCCard
                          title={"Re-Initiate KYC."}
                          onPress={() => {
                            setKYCReduModel(true);
                          }}
                          buttonTitle="Check Status"
                        />
                      ) : activeKYCCard ? (
                        <KYCCard
                          subtitle={"KYC completed sucessfully"}
                          onPress={() => {
                            setValue("2");
                          }}
                          buttonTitle=""
                        />
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid md={12} container>
                    <Grid
                      item
                      md={9}
                      xs={12}
                      sx={{
                        pt: 4,
                      }}
                    >
                      <Box
                        sx={{
                          height: "45%",
                          display: {
                            xs: "none",
                            md: "block",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            height: "100%",
                            borderRadius: 2,
                            overflow: "hidden",
                          }}
                        >
                          <Carousel
                            animation="slide"
                            indicatorContainerProps={{
                              style: { display: "none" },
                            }}
                            {...carouselSettings}
                            sx={{
                              height: "100%",
                            }}
                          >
                            {dashboardCoursalItems.map(
                              (item: any, index: any) => (
                                <Box
                                  sx={{
                                    borderRadius: 5,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    background: item.bgColor,
                                    flexDirection: {
                                      xs: "column",
                                      sm: "column",
                                      md: "row",
                                    },
                                    pt: 2.2,
                                    pb: 2.2,
                                    boxShadow: 0.4,
                                    minHeight: 150,
                                  }}
                                >
                                  <Box
                                    component="img"
                                    sx={{
                                      height: {
                                        xs: "60%",
                                        sm: "60%",
                                        md: "50%",
                                      },
                                      width: {
                                        xs: "60%",
                                        sm: "60%",
                                        md: "15%",
                                      },
                                      display: {
                                        xs: "none",
                                        md: "block",
                                      },
                                    }}
                                    src={item.leftImage}
                                    alt="saas-dasboard-footer"
                                  />

                                  <Box
                                    sx={{
                                      width: {
                                        xs: "80%",
                                        sm: "80%",
                                        md: "90%",
                                      },

                                      alignItems: "center",
                                      justifyContent: "center",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <H4
                                      fontSize={22}
                                      sx={{
                                        textAlign: "center",
                                        fontFamily: "'Poppins', sans-serif",
                                      }}
                                      color={item.textColor}
                                    >
                                      {item.startText}
                                      <H4
                                        fontSize={22}
                                        sx={{
                                          textAlign: "center",
                                          fontFamily: "'Poppins', sans-serif",
                                        }}
                                        fontWeight={700}
                                        color={item.middleTextColor}
                                      >
                                        {item.middleText}
                                      </H4>
                                      {item.endText}
                                    </H4>
                                    <Button
                                      onClick={() => {
                                        if (item.type === "mutual") {
                                          setValue("3");
                                        }
                                        if (item.type === "goal") {
                                          navigate("/goalDashboard");
                                        }
                                        if (item.type === "gold") {
                                          setValue("2");
                                          setType("Gold");
                                        }
                                        if (item.type === "silver") {
                                          setValue("2");
                                          setType("Silver");
                                        }
                                      }}
                                      type="submit"
                                      size="medium"
                                      disableElevation
                                      disableRipple
                                      sx={{
                                        background: item.buttonColor,
                                        width: "25%",
                                        borderRadius: 10,
                                        color: "#ffff",
                                        textTransform: "none",
                                      }}
                                    >
                                      {item.buttonText}
                                    </Button>
                                  </Box>
                                  <Box
                                    component="img"
                                    sx={{
                                      height: {
                                        xs: "60%",
                                        sm: "60%",
                                        md: index === 2 ? "20%" : "50%",
                                      },
                                      width: {
                                        xs: "60%",
                                        sm: "60%",
                                        md: "15%",
                                      },
                                      display: {
                                        xs: "none",
                                        md: "block",
                                      },
                                    }}
                                    src={item.rightImage}
                                    alt="saas-dasboard-footer"
                                  />
                                </Box>
                              )
                            )}
                          </Carousel>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          height: "100%",
                        }}
                      >
                        <H3
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            mb: {
                              md: 1,
                              xs: -2,
                            },
                            ml: {
                              md: 0,
                              xs: 1,
                            },
                            mt: {
                              md: 1,
                              xs: -3,
                            },
                          }}
                        >
                          Our Offerings
                        </H3>
                        <Grid
                          sx={{
                            mt: {
                              md: 2,
                              xs: 0,
                            },
                            width: {
                              xs: "90%",
                              sm: "100%",
                              md: "100%",
                            },
                            display: {
                              xs: "column",
                              md: "flex",
                            },
                          }}
                        >
                          <StaticCard
                            onPress={() => {
                              setType("Gold");
                              setValue("2");
                            }}
                            title={"Digital Gold"}
                            description={
                              "Grow your wealth with the safety and security of digital gold investment"
                            }
                            image="https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                          />
                          <StaticCard
                            onPress={() => {
                              setValue("2");

                              setType("Silver");
                            }}
                            title={"Digital Silver"}
                            description={
                              "Get started with digital silver investment in just a few clicks"
                            }
                            image="https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
                          />
                          <StaticCard
                            onPress={() => setValue("3")}
                            title={"Mutual Funds"}
                            description={
                              "Invest confidently in top-performing mutual funds"
                            }
                            image="https://acru-asset.s3.us-east-1.amazonaws.com/assets/mf.svg"
                          />
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      md={3}
                      xs={12}
                      sx={{
                        pt: {
                          md: 4,
                          xs: 0,
                        },
                        pl: {
                          md: 4,
                          xs: 0,
                        },

                        mr: -8,
                      }}
                    >
                      <Box
                        sx={{
                          background:
                            "linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%);",
                          flexDirection: "column",
                          display: {
                            md: "flex",
                            xs: "none",
                          },
                          justifyContent: "space-between",
                          borderRadius: 2,
                          alignItems: "center",
                          pt: 2,
                          pb: 2,
                          ml: {
                            md: 1,
                            xs: 0,
                          },
                          mt: {
                            md: 0,
                            xs: 3,
                          },
                        }}
                      >
                        <Box
                          component="img"
                          src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/appbanner.svg"
                          sx={{
                            height: 180,
                            width: 210,
                          }}
                        />
                        <H4
                          color="#000"
                          fontWeight={"400"}
                          sx={{
                            width: "60%",
                            textAlign: "center",
                            mt: 2,
                            mb: 2,
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          Take your investment journey to the next level, scan
                          to download our app now
                        </H4>
                        <Box
                          component="img"
                          src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/qr.svg"
                          sx={{
                            height: 100,
                            width: 100,
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <H3
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      mb: {
                        md: 2,
                        xs: 0,
                      },
                      mt: 4,
                      ml: {
                        md: 0,
                        xs: 1,
                      },
                    }}
                  >
                    Explore
                  </H3>
                  <Grid
                    container
                    sx={{
                      justifyContent: "space-between",
                      mb: 5,
                    }}
                  >
                    {DashboardCardData.map((item: any, index: any) => (
                      <DashBoardCard
                        index={index}
                        heading={item?.name}
                        bgColor={item?.bgColor}
                        subheading={item?.subheading}
                        image={item?.icon}
                        onPress={() => {
                          onClickBottomCard(item?.name);
                        }}
                      />
                    ))}
                  </Grid>
                </>
              )}
              <KYCReduModel
                open={kycReduModel}
                handleClose={handleKYCReduCloseModal}
                handleSave={handleSaveKYCReduModel}
              />
              {value === "2" && <DigitalGoldTabScreen type={type} />}
              {value === "3" && <MFDashboard />}
              {value === "4" && (
                <Grid
                  sx={{
                    height: "100vh",
                    mt: 20,
                    mb: 20,
                  }}
                >
                  <Player
                    autoplay
                    loop
                    src={ComingSoon}
                    style={{
                      height: "300px",
                      width: "300px",
                    }}
                  />
                </Grid>
              )}
            </>
          )}
        </Box>
      </TabContext>
      <Footer />
    </Grid>
  );
};

const sxStyleTabBox = {
  pl: {
    xs: 2,
    sm: 1,
    md: 10,
  },
  pr: {
    xs: 2,
    sm: 1,
    md: 10,
  },
  marginTop: {
    xs: 1,
    sm: 1,
    md: 2,
  },
  textTransform: "none",
};

const sxStyleCardView = {
  marginTop: 2,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "column",
    md: "row",
  },
  justifyContent: "space-between",
};

const sxStyleCard = {
  ml: {
    xs: 0.2,
    sm: 1.2,
    md: 0,
  },
  mt: {
    xs: 0,
    sm: 1,
    md: 2,
  },
  width: {
    xs: "90%",
    sm: "90%",
    md: "78%",
  },
  display: "flex",
  flexDirection: {
    md: "row",
    xs: "column",
  },
};

const sxStyleExtraCard = {
  ml: {
    xs: 0.2,
    sm: 1.2,
    md: 0,
  },
  mt: 2,
  width: {
    xs: "98%",
    sm: "93%",
    md: "22%",
  },
};
const tabStyle = {
  fontSize: {
    md: 16,
    xs: 12,
  },
  fontWeight: 500,
  color: "#000",
  fontFamily: "'Poppins', sans-serif",
  textTransform: "none",
};

export default Dashborad;
